module.exports = __webpack_public_path__ + "img/ID.a8b91860.svg";